export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_15.6e38b5df.jpg";